import { render, staticRenderFns } from "./FileInlinePreview.vue?vue&type=template&id=4d5ca1fa&"
import script from "./FileInlinePreview.vue?vue&type=script&lang=js&"
export * from "./FileInlinePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports